import { createSlice } from '@reduxjs/toolkit'

const featureFlagSlice = createSlice({
  name: 'featureFlag',
  initialState: {
    details: [],
  },
  reducers: {
    setFeatureFlag: (state, action) => {
      state.details = action.payload
    },
  },
})
export const { setFeatureFlag } = featureFlagSlice.actions

export default featureFlagSlice.reducer
